import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  permission: null, // 'granted', 'denied', or null
  coordinates: null, // Current coordinates
  coordinatesSource: null, // 'gps' | 'ip' | 'fallback' | 'manual' | null
  temporaryCoordinates: null, // Temporary location coordinates
  locationName: null, // Temporary location name
  tempLocationName: null,
  loading: false,
  error: null,
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setPermission: (state, action) => {
      state.permission = action.payload;
    },
    setCoordinates: (state, action) => {
      const payload = action.payload;
      let coordinates;
      let source;
      if (Array.isArray(payload)) {
        coordinates = payload;
        source = 'manual';
      } else if (payload && typeof payload === 'object') {
        coordinates = payload.coordinates;
        source = payload.source || 'manual';
      } else {
        coordinates = null;
        source = null;
      }
      state.coordinates = coordinates;
      state.coordinatesSource = source;
      sessionStorage.setItem('coordinates', JSON.stringify(coordinates));
      sessionStorage.setItem('coordinatesSource', JSON.stringify(source));
    },
    setLocationName: (state, action) => { // NEW ACTION
      state.locationName = action.payload;
      sessionStorage.setItem('locationName', JSON.stringify(action.payload));
    },
    setTemporaryCoordinates: (state, action) => {
      state.temporaryCoordinates = action.payload.coordinates;
      state.tempLocationName = action.payload.tempLocationName; // Store the location name
      sessionStorage.setItem('temporaryCoordinates', JSON.stringify(action.payload.coordinates));
      sessionStorage.setItem('tempLocationName', JSON.stringify(action.payload.tempLocationName));
    },
    resetTemporaryCoordinates: (state) => {
      state.temporaryCoordinates = null;
      state.tempLocationName = null;
      sessionStorage.removeItem('tempLocationName');
      sessionStorage.removeItem('temporaryCoordinates');
    },
  },
});

export const {
  setPermission,
  setCoordinates,
  setLocationName,
  setTemporaryCoordinates,
  resetTemporaryCoordinates,
} = locationSlice.actions;

export const initializeCoordinates = () => (dispatch) => {
  try {
    const savedCoordinates = sessionStorage.getItem('coordinates');
    const savedCoordinatesSource = sessionStorage.getItem('coordinatesSource');
    const savedTemporaryCoordinates = sessionStorage.getItem('temporaryCoordinates');
    const savedLocationName = sessionStorage.getItem('locationName');
    const savedTempLocationName = sessionStorage.getItem('tempLocationName');

    if (savedCoordinates && savedLocationName) {
      const coords = JSON.parse(savedCoordinates);
      const source = savedCoordinatesSource
        ? JSON.parse(savedCoordinatesSource)
        : 'manual';
      dispatch(setCoordinates({ coordinates: coords, source }));
      dispatch(setLocationName(JSON.parse(savedLocationName)));
    }

    if (savedTemporaryCoordinates && savedTempLocationName) {
      dispatch(
        setTemporaryCoordinates({
          coordinates: JSON.parse(savedTemporaryCoordinates),
          tempLocationName: JSON.parse(savedTempLocationName),
        })
      );
    }
    
  } catch (error) {
    console.error('Failed to rehydrate location data:', error);
    sessionStorage.removeItem('temporaryCoordinates');
    sessionStorage.removeItem('locationName');
  }
};

// Selector for current effective coordinates
export const selectEffectiveCoordinates = (state) =>
  state.location.temporaryCoordinates || state.location.coordinates;

// Selector for current effective location name
export const selectEffectiveLocationName = (state) =>
  state.location.tempLocationName || state.location.locationName;


export const selectEffectiveCoordinatesAreReal = (state) => {
  if (state.location.temporaryCoordinates) return true;
  if (!state.location.coordinates) return false;
  return state.location.coordinatesSource !== 'fallback';
};

export default locationSlice.reducer;
